"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.File = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@ark-ui/react");
const react_3 = require("@chakra-ui/react");
const Text = __importStar(require("../../Text/Text"));
const Button_1 = require("../../Button/Button");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const free_regular_svg_icons_1 = require("@fortawesome/free-regular-svg-icons");
const Alert_1 = require("../../Alert/Alert");
const react_4 = require("@chakra-ui/react");
require("./File.css");
const Labels_1 = require("../Labels");
const File = ({ provider, label, helperText, fileTypes, isLoading, }) => {
    const Icon = (0, react_4.chakra)(react_fontawesome_1.FontAwesomeIcon);
    const UploadBody = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_3.HStack, { gap: '8px', py: '4px' },
            react_1.default.createElement(Button_1.Button, { buttonAppearance: 'outline', intent: 'neutral', leftIcon: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faDownload }) }, "Upload"),
            react_1.default.createElement(Text.Contrast, { size: 'xs', appearance: 'low', weight: 'semibold' }, "or drag it here")),
        fileTypes && fileTypes.length > 0 && (react_1.default.createElement(Text.Status, { size: 'xxs', appearance: 'neutral' },
            "Accepts ",
            fileTypes.join(', ')))));
    const LoadingBody = (react_1.default.createElement(Text.Status, { size: 'xs', appearance: 'prominent' }, "Uploading file(s)..."));
    return (react_1.default.createElement(react_2.FileUpload.RootProvider, { value: provider },
        react_1.default.createElement(react_2.FileUpload.Label, null,
            react_1.default.createElement(Labels_1.Labels, { label: label, helperText: helperText })),
        react_1.default.createElement(react_2.FileUpload.Dropzone, { "data-loading": isLoading }, isLoading ? LoadingBody : UploadBody),
        react_1.default.createElement(react_2.FileUpload.Context, null, ({ acceptedFiles, rejectedFiles }) => {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                acceptedFiles.map(file => (react_1.default.createElement(react_2.FileUpload.ItemGroup, { key: file.name },
                    react_1.default.createElement(react_2.FileUpload.Item, { file: file },
                        react_1.default.createElement(react_2.FileUpload.ItemPreview, { type: "image/*" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_regular_svg_icons_1.faFileImage })),
                        react_1.default.createElement(react_2.FileUpload.ItemPreview, { type: "audio/*" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_regular_svg_icons_1.faFileAudio })),
                        react_1.default.createElement(react_2.FileUpload.ItemPreview, { type: "video/*" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_regular_svg_icons_1.faFileVideo })),
                        react_1.default.createElement(react_2.FileUpload.ItemPreview, { type: "text/*" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_regular_svg_icons_1.faFileLines })),
                        react_1.default.createElement(react_2.FileUpload.ItemPreview, { type: "application/*" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_regular_svg_icons_1.faFileLines })),
                        react_1.default.createElement(react_2.FileUpload.ItemPreview, { type: "font/*" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_regular_svg_icons_1.faFileLines })),
                        react_1.default.createElement(react_2.FileUpload.ItemName, null),
                        react_1.default.createElement(react_2.FileUpload.ItemSizeText, null),
                        react_1.default.createElement(react_2.FileUpload.ItemDeleteTrigger, null,
                            react_1.default.createElement(Icon, { bgColor: '#E1F5EB', _hover: { bgColor: '#E1F5EB' }, _active: { bgColor: '#E1F5EB' }, "aria-label": 'delete', icon: free_regular_svg_icons_1.faCircleXmark })))))),
                rejectedFiles.map(rejected => (react_1.default.createElement(react_2.FileUpload.ItemGroup, { "data-rejected": true, key: rejected.file.name },
                    react_1.default.createElement(react_2.FileUpload.Item, { key: rejected.file.name, file: rejected.file },
                        react_1.default.createElement(react_2.FileUpload.ItemName, null,
                            react_1.default.createElement(Alert_1.Alert, { contained: false, description: `${rejected.file.name}: ${rejected.errors[0]}`, status: 'negative' })),
                        react_1.default.createElement(react_4.IconButton, { variant: 'ghost', isRound: true, colorScheme: 'white', "aria-label": 'delete', icon: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { style: { color: '#F2502B' }, icon: free_regular_svg_icons_1.faCircleXmark }), onClick: () => provider.clearRejectedFiles() })))))));
        }),
        react_1.default.createElement(react_2.FileUpload.HiddenInput, null)));
};
exports.File = File;
